import { Outlet, useLocation } from "react-router-dom";
import MainHeader from "../../components/pages/common/MainHeader";
import Sidebar from "../../components/pages/common/Sidebar";
import { AutomationWrapper } from "../../components/styleComponents";
import { allData } from "./LayoutContent";
import { Waypoint } from "react-waypoint";

export default function AutomationLayout({ handleWaypointEnter, handleWaypointLeave }) {
  const pathName = useLocation().pathname;
  const pathSegments = pathName.split("/");
  const key = pathSegments[1];
  const data = allData[key];
  return (
    <>
      <MainHeader heading="AI Agents" />
			<Waypoint onEnter={handleWaypointEnter} onLeave={handleWaypointLeave} />
      <AutomationWrapper>
        <Sidebar data={data} url={key}/>
        <Outlet />
      </AutomationWrapper>
    </>
  );
}
